import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  &.blue .edit-pencil {
    fill: ${({ theme }) => theme.colors.text05};
  }
  &.teal .edit-pencil {
    fill: ${({ theme }) => theme.colors.brand03};
  }
  &.small {
    width: 14px;
    height: 14px;
    padding: 0;
  }
`;
export const EditIcon = (props) => (
  <SVG {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        className="edit-pencil"
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </SVG>
);
